import { cn } from 'src/shared/lib/utils';

interface LoadingProps {
  color?: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export function Loading({ color, size = 15, strokeWidth = 4, className }: LoadingProps) {
  return (
    <div
      className={cn(`flex items-center justify-center`, className)}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <svg id="loading-svg" viewBox="25 25 50 50">
        <circle id="loading-circle" strokeWidth={strokeWidth} cx="50" cy="50" r="20" stroke={color || 'black'} />
      </svg>
    </div>
  );
}
